"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _exchangeUiComponents = require("@mulesoft/exchange-ui-components");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _hooks = require("./hooks");
var _events = require("../../analytics/events");
var _Search = _interopRequireDefault(require("./Search"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  "search-container": "SearchWrapper__search-container__3Hh1s",
  "searchContainer": "SearchWrapper__search-container__3Hh1s"
}; 
require('./SearchWrapper.css');
var SearchWrapper = function SearchWrapper(_ref) {
  var asset = _ref.asset;
  var _React$useState = _react.default.useState(false),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    isSearchOpen = _React$useState2[0],
    setIsSearchOpen = _React$useState2[1];
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var searchRef = (0, _react.useRef)();
  var openSearch = (0, _react.useCallback)(function (event) {
    var _searchRef$current;
    setIsSearchOpen(true);
    event.preventDefault();
    (_searchRef$current = searchRef.current) === null || _searchRef$current === void 0 || _searchRef$current.focus();
    trackEvent(_events.EVENT_TYPES.OPENED_PORTAL_SEARCH, _objectSpread({}, (0, _events.assetProperties)({
      asset: asset
    })));
  }, []);
  var closeSearch = (0, _react.useCallback)(function () {
    trackEvent(_events.EVENT_TYPES.CLOSED_PORTAL_SEARCH, _objectSpread({}, (0, _events.assetProperties)({
      asset: asset
    })));
    setIsSearchOpen(false);
  }, []);

  // Listen for custom events
  (0, _react.useEffect)(function () {
    global.document.addEventListener('exchange-portal-search', openSearch);
    return function () {
      global.document.removeEventListener('exchange-portal-search', openSearch);
    };
  }, [openSearch]);
  (0, _hooks.useShortcut)('cmd+f', openSearch);
  (0, _hooks.useShortcut)('esc', closeSearch);
  var searchStyle = (0, _react.useMemo)(function () {
    return {
      visibility: isSearchOpen ? 'visible' : 'hidden'
    };
  }, [isSearchOpen]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.searchContainer,
    style: searchStyle,
    key: "".concat(asset.groupId).concat(asset.assetId),
    "data-test-id": "search-container"
  }, /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.ErrorBoundary, null, /*#__PURE__*/_react.default.createElement(_Search.default, {
    ref: searchRef,
    disabled: !isSearchOpen,
    asset: asset,
    onClose: closeSearch
  })));
};
var _default = exports.default = SearchWrapper;
//# sourceMappingURL=SearchWrapper.js.map